const endpoints = {
  //Authentication
  login: "/api/customers/login",
  signup: "/api/customers/register",
  logout: "/api/customers/logout",
  resetPassword: "/api/customers/password/reset",
  forgotPassword: "/api/customers/password/forgot",
  me: "/api/customers/me",
  googleLogin: "/api/customers/login/google",
  facebookLogin: "/api/customers/login/facebook",
  profile: "/api/customers/profile",
  passwordChange: "/api/customers/update_password",
  deleteAccount: "/api/customers/account/delete/request",
  deleteAccountConfirm: "/api/customers/account/delete",
  resendVerification: "/api/customers/email/resend-verification",
  //Restaurant Listing
  restaurantList: "/api/listing/restauants-list",
  //Restaurant Details
  restaurantDetails: "/api/customers/restaurants/single/details",
  restaurantRating: "/api/customers/restaurants/{{restaurant_id}}/rating",
  restaurantPersonalNote:
    "/api/customers/restaurants/{{restaurant_id}}/personal-note",
  //categories
  categories: "/api/listing/categories",
  //wishlist
  wishlist: "/api/customers/restaurants/wishlist",

  //stripe
  financialConnectionsSession: "/api/customers/financial-connections/session",
  financialConnectionsSessionComplete:
    "/api/customers/financial-connections/session/complete",
  financialConnectionsAccount: "/api/customers/financial-connections/account",
  financialConnectionsAccounts: "/api/customers/financial-connections/accounts",

  //game
  miniGames: "/api/customers/mini-games",
  miniGamesPassport: "/api/customers/mini-games/passport",
  miniGamesPassportRestaurants:
    "/api/customers/mini-games/passport/restaurants",
  games: "/api/customers/games",
  game: "/api/customers/games/{{game_slug}}",

  //point-ledger
  pointsBalance: "/api/customers/points/balance",
  pointsLedger: "/api/customers/points/ledger",

  //redeemption
  pointsRedemptionTiers: "/api/customers/points/redemption-tiers",
  vouchers: "/api/customers/vouchers",
  voucher: "/api/customers/vouchers/1",

  //referral
  referralCode: "/api/customers/referrals/code",
  referralStats: "/api/customers/referrals/stats",
  referralFriends: "/api/customers/referrals/friends",

  //global FAQs
  globalFAQs: "/api/customers/global-faqs",

  //games
  gamesStats: "/api/customers/games/stats",

  //transaction
  walletTransactions: "/api/customers/wallet/transactions?per_page=20",

  //notifications
  notificationsAll: "/api/customers/notifications?status=all",
  notificationsUnread: "/api/customers/notifications?status=unread",
  notificationsRead: "/api/customers/notifications?status=read",
  unreadCount: "/api/customers/notifications/unread-count",
  markAllNotificationsRead: "/api/customers/notifications/read-all",
  markNotificationRead: "/api/customers/notifications/{{NOTIFICATION_ID}}/read",
  markNotificationUnread:
    "/api/customers/notifications/{{NOTIFICATION_ID}}/unread",
  fcmToken: "/api/fcm-token",
  notificationSettings: "/api/customers/notification-settings",

  // Resturant portal endpoints

  //auth
  restaurantLogin: "/api/restaurants/login",
  restaurantForgotPassword: "/api/restaurants/forgot-password",
  restaurantResetPassword: "/api/restaurants/reset-password",
  restaurantTerminalCodeLogin: "/api/restaurants/terminal-code/login",
  restaurantEmailVerification: "/api/restaurants/email/verification",

  //redeem
  restaurantVouchersRedeem: "/api/restaurants/vouchers/redeem",
  vouchersRedeem: "/api/vouchers/redeem",
  restaurantTerminalCode: "/api/restaurants/terminal-code",

  //profile
  restaurantProfile: "/api/restaurants/profile",
  restaurantCredentials: "/api/restaurants/credentials",
  restaurantMe: "/api/restaurants/me",

  //stripe
  restaurantStripeConnectAccounts: "/api/restaurants/stripe/connect-accounts",
  restaurantStripeConnectAccount:
    "/api/restaurants/stripe/connect-accounts/{{connect_account_id}}",
  restaurantStripeConnectAccountsActivationLink:
    "/api/restaurants/stripe/connect-accounts/activation-link",
  restaurantStripeConnectAccountsRefresh:
    "/api/restaurants/stripe/connect-accounts/refresh",
  restaurantStripeConnectTopups: "/api/restaurants/connect/topups",
  restaurantStripeConnectTransactions: "/api/restaurants/connect/transactions",
  restaurantStripeConnectBalance: "/api/restaurants/connect/balance",

  //Restaurant Platform fee
  restaurantPlatformFees: "/api/restaurants/platform-fees",
  restaurantPlatformFeesSummary: "/api/restaurants/platform-fees/summary",

  //Restaurant Dashboard
  restaurantDashboard: "/api/restaurants/dashboard/stats",
  restaurantDashboardRedeems: "/api/restaurants/dashboard/redeems",
  restaurantDashboardRecentRedemptions:
    "/api/restaurants/dashboard/recent-redemptions",
  restaurantDashboardCurrentSettlement:
    "/api/restaurants/dashboard/current-settlement",
  restaurantDashboardSettlements: "/api/restaurants/dashboard/settlements",
  restaurantDashboardTopCustomers: "/api/restaurants/dashboard/top-customers",
  restaurantDashboardCustomerSpendBreakdown:
    "/api/restaurants/dashboard/customer-spend-breakdown",
  restaurantDashboardActivity: "/api/restaurants/activity",
  restaurantDashboardProfile: "/api/restaurants/profile",
  restaurantDashboardCredentials: "/api/restaurants/credentials",
  restaurantAllRedemptions: "/api/restaurants/all-redemptions",
  restaurantPastSettlements: "/api/restaurants/settlements/past",
  restaurantSettlementInvoices: "/api/restaurants/settlement-invoices",
  restaurantSettlementInvoice: "/api/restaurants/settlement-invoices/{{invoice_id}}",
  restaurantMarketInsightsShareOfWallet: "/api/restaurants/customer-insights",

  //Restaurant Staff
  restaurantDashboardStaffPermissions: "/api/restaurants/staff/permissions",
  restaurantDashboardStaff: "/api/restaurants/staff",
  restaurantExport: "/api/restaurants/export",

  //Restaurant Notifications
  restaurantNotificationsAll: "/api/restaurants/notifications?status=all",
  restaurantNotificationsUnread: "/api/restaurants/notifications?status=unread",
  restaurantNotificationsRead: "/api/restaurants/notifications?status=read",
  restaurantNotificationsUnreadCount:
    "/api/restaurants/notifications/unread-count",
  restaurantNotificationMarkRead:
    "/api/restaurants/notifications/{{NOTIFICATION_ID}}/read",
  restaurantNotificationMarkUnread:
    "/api/restaurants/notifications/{{NOTIFICATION_ID}}/unread",
  restaurantNotificationsReadAll: "/api/restaurants/notifications/read-all",
  restaurantNotificationSettings: "/api/restaurants/notification-settings",

  //Restaurant Settings
  restaurantDashboardSettings: "/api/restaurants/settings",
  restaurantDashboardSettlementsImpactReport:
    "/api/restaurants/settlements/impact-report",
  restaurantLogout: "/api/restaurants/logout",

  //Admin portal endpoints

  //auth
  adminLogin: "/api/login",
  adminLogout: "/api/logout",
  adminForgotPassword: "/api/admin/forgot-password",
  adminResetPassword: "/api/admin/reset-password",
  adminStreakSettings: "/api/streak-settings",
  adminStreakSettingsById: "/api/streak-settings/1",

  //points redemption tiers
  adminPointsRedemptionTiers: "/api/points-redemption-tiers",
  adminPointsRedemptionTier: "/api/points-redemption-tiers/{{id}}",

  //dashboard
  adminDashboardListingCounts: "/api/dashboard-listing/counts",
  adminDashboardLinkedCardsStat: "/api/dashboard-listing/linked-cards-stat",
  adminDashboardNetworkLeakageStat:
    "/api/dashboard-listing/network-leakage-stat",
  adminDashboardPlatformFloatStat: "/api/dashboard-listing/platform-float-stat",
  adminDashboardPartnerPerformanceSummary:
    "/api/dashboard-listing/partner-performance-summary",
  adminDashboardPartnerPerformanceBreakdown:
    "/api/dashboard-listing/partner-performance-breakdown",
  adminDashboardTopRecruitmentTargets:
    "/api/dashboard-listing/top-recruitment-targets",
  adminDashboardRecentNetworkTransactions:
    "/api/dashboard-listing/recent-network-transactions",

  //members
  adminAllUsers: "/api/all-users",
  adminAllFreeUsers: "/api/all-free-users",
  adminAllDeletedDeactivatedUsers: "/api/all-deleted-deactivated-users",
  adminAllDeactivatedUsers: "/api/all-deleted-deactivated-users?status=deleted",
  adminAllGiftedUsers: "/api/all-gifted-users",
  adminAllAdminUsers: "/api/all-admin-users",
  adminSingleUserRecord: "/api/single-user-record/{{user_id}}",
  adminCreateUser: "/api/create-user",
  adminChangeUserStatus: "/api/user/change-status",
  adminUpdateUserData: "/api/update-user-data",
  adminDeleteUser: "/api/delete-user/{{user_id}}",
  adminRestoreUser: "/api/restore-user/{{user_id}}",
  adminDeleteUserPermanently: "/api/delete-user/{{user_id}}?permanently=1",
  adminUpdateUserPasswordByAdmin: "/api/user/update-password-by-admin",
  adminManageUserPoints: "/api/members/{{user_id}}/manage-points",
  adminUserVouchers: "/api/users/vouchers",
  adminMemberGames: "/api/admin/member-games",
  adminReferrals: "/api/admin/referrals",
  adminWishlists: "/api/admin/wishlists",

  //Restaurants
  adminAllRestaurants: "/api/all-listing?page=1",
  adminSingleRestaurant: "/api/single-business-listing/{{listing_id}}",
  adminDeleteRestaurant: "/api/delete-business-listing/{{listing_id}}",
  adminVendorListingStatus: "/api/vendor-listing-status",
  adminArchiveRestaurant: "/api/archive-business",
  adminAddRestaurant: "/api/add-business-listing",
  adminChangeSponsoredShip: "/api/change-sponsored-ship",
  adminUpdateRestaurant: "/api/update-business-listing/{{listing_id}}",
  adminRestaurantPerformance: "/api/restaurants/{{listing_id}}/performance",
  adminRestaurantsAdmins: "/api/restaurants/admins",
  adminRestaurantsStaff: "/api/admin/restaurants/{{restaurant_id}}/staff",
  adminRestaurantsStaffCreate: "/api/restaurants/admins",
  adminRestaurantsStaffUpdate:
    "/api/admin/restaurants/{{restaurant_id}}/staff/{{staff_user_id}}",
  adminRestaurantsStaffDelete:
    "/api/admin/restaurants/{{restaurant_id}}/staff/{{staff_user_id}}",
  adminRestaurantsStaffUpdatePassword:
    "/api/admin/restaurants/{{restaurant_id}}/staff/{{staff_user_id}}",
  adminStaffProfile: "/api/restaurants/staff/{{staff_id}}",
  adminRestaurantsPlatformFees: "/api/admin/restaurants/platform-fees",
  adminRestaurantsPlatformFeesSummary:
    "/api/admin/restaurants/platform-fees/summary",
  adminRestaurantsPlatformFeesPercentage:
    "/api/admin/restaurants/platform-fees/percentage",
  adminRestaurantsPlatformFeesMarkPaid:
    "/api/admin/restaurants/platform-fees/mark-paid",
  adminRestaurantsPlatformFeesRequestDeduction:
    "/api/restaurants/platform-fees/request-deduction",
  adminRestaurantsPlatformFeesRequestDeductionBatch:
    "/api/admin/restaurants/platform-fees/request-deduction/batch",
  adminRestaurantsCredentials: "/api/restaurants/credentials",
  adminRestaurantsRedemptions: "/api/restaurants/redemptions",
  adminRestaurantReviews: "/api/reviews?vendor_listing_id={{listing_id}}",
  adminRestaurantVouchers:
    "/api/users/vouchers?vendor_listing_id={{listing_id}}",
  adminRestaurantCustomers:
    "/api/admin/restaurant-customers?vendor_listing_id={{listing_id}}",
  adminRestaurantSettlementInvoices:
    "/api/admin/settlement-invoices?vendor_listing_id={{listing_id}}&per_page=20",
  adminRestaurantPointsLedger:
    "/api/points-ledger?vendor_listing_id={{listing_id}}",

  //leakages
  adminRecruitmentLeakageOverview: "/api/recruitment-leakage/overview",
  adminRecruitmentLeakageTopTargets:
    "/api/recruitment-leakage/top-targets?limit=5&sort=highest_spend",
  adminRecruitmentLeakageNetworkTransactions:
    "/api/recruitment-leakage/network-transactions",
  adminRecruitmentLeakageFullTransactionFeed:
    "/api/recruitment-leakage/full-transaction-feed",

  //platform fees
  adminPlatformFeesOverview: "/api/platform-fees/overview",
  adminPlatformFeesTopTargets:
    "/api/platform-fees/top-targets?limit=5&sort=highest_fees",
  adminPlatformFeesTransactions: "/api/platform-fees/transactions",
  adminPlatformFeesFullFeed: "/api/platform-fees/full-transaction-feed",

  //points-ledger
  adminPointsLedger: "/api/points-ledger",
  adminUserPointsLedger: "/api/users/{{user_id}}/points-ledger",

  //passport
  adminPassportSettings: "/api/passport-settings",

  //rewards
  adminRewardEconomics: "/api/platform-settings/reward-economics",
  adminProfile: "/api/admin/profile",

  //games
  adminGames: "/api/games",
  adminGame: "/api/games/{{game_slug}}",
  adminDeleteGame: "/api/games/{{game_slug}}",
  allListing: "/api/all-listing",
  listingCategories: "/api/listing/categories",

  //ofl
  adminUserOflRewards: "/api/users/{{user_id}}/ofl-rewards",
  adminRestaurantOflRewards:
    "/api/restaurants/{{vendor_listing_id}}/ofl-rewards",
  //settlements
  adminSettlementsDashboard: "/api/admin/settlements/dashboard",
  adminRestaurantsPlatformFeesSummaryByStatus:
    "/api/admin/restaurants/platform-fees/summary",
  adminSettlementsUpcomingWeekly: "/api/admin/settlements/upcoming-weekly",
  adminSettlementsCurrentPeriodBalances:
    "/api/admin/settlements/current-period-balances",
  adminSettlementsRecentRuns: "/api/admin/settlements/recent-runs",
  adminSettlementInvoices: "/api/admin/settlement-invoices",
  adminSettlementInvoiceStatus:
    "/api/admin/settlement-invoices/{{invoice_id}}/status",
  adminSettlementInvoiceDownload:
    "/api/admin/settlement-invoices/{{invoice_id}}/download",
  adminPlatformFeesMarkPaid: "/api/admin/restaurants/platform-fees/mark-paid",

  adminCustomersFinancialAccounts: "/api/admin/customers/financial-accounts",
  adminDeleteCustomerFinancialAccount:
    "/api/admin/customers/financial-accounts/{{financial_account_id}}",
  adminRestaurantsConnectAccounts: "/api/admin/restaurants/connect-accounts",
  adminDeleteRestaurantConnectAccount:
    "/api/admin/restaurants/connect-accounts/{{connect_account_id}}",
  adminExport: "/api/admin/export",

  adminActivityLogs: "/api/activity-logs",
  adminActivityLog: "/api/activity-logs/{{activity_id}}",

  //Admin Notifications
  adminNotificationsAll:
    "/api/admin/notifications?status=all&page=1&page_size=10",
  adminNotificationsUnread:
    "/api/admin/notifications?status=unread&page=1&page_size=10",
  adminNotificationsRead:
    "/api/admin/notifications?status=read&page=1&page_size=10",
  adminNotificationsUnreadCount: "/api/admin/notifications/unread-count",
  adminNotificationMarkRead:
    "/api/admin/notifications/{{NOTIFICATION_ID}}/read",
  adminNotificationMarkUnread:
    "/api/admin/notifications/{{NOTIFICATION_ID}}/unread",
  adminNotificationsReadAll: "/api/admin/notifications/read-all",

  //Admin FAQs
  adminGlobalFAQs: "/api/admin/global-faqs",
  adminGlobalFAQ: "/api/admin/global-faqs/{{global_faq_id}}",

  //Platform Settings
  platformSettingsAccountSecurity: "/api/platform-settings/account-security",
};

export default endpoints;
